var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Italy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,4c-2.846,0-5.549,0.604-8,1.675v36.649C18.451,43.396,21.154,44,24,44s5.549-0.604,8-1.675 V5.675C29.549,4.604,26.846,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M32,5.675v36.649C39.061,39.237,44,32.199,44,24C44,15.801,39.061,8.763,32,5.675z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#689f38",
    d: "M4,24c0,8.199,4.939,15.237,12,18.325V5.675C8.939,8.763,4,15.801,4,24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Italy);
export default __webpack_public_path__ + "static/media/icons8-italy.d83bc30086c11270b6c4664b88471e01.svg";
export { ForwardRef as ReactComponent };